// extracted by mini-css-extract-plugin
module.exports = {"EmptyProducts":"style_EmptyProducts__N0Fzk"};